const e = "oraz", o = "Wróć", a = "Zamknij", i = "Kontynuuj", n = "dni", s = "d", t = "E-mail", r = "Witajcie.", l = "godziny", d = "h", y = "minuty", c = "min", w = "Żaden", X = "Nieobowiązkowo", u = "Zarejestruj się", m = "sekundy", z = "s", k = "Klikając ten link, wyrażasz zgodę na otrzymywanie wiadomości i promocji od naszej marki. Zgodnie z ogólnym rozporządzeniem o ochronie danych (GDPR) informujemy, że Twoje dane zostaną włączone do naszych baz danych. Jako klient możesz swobodnie znać i uzyskiwać dostęp do danych osobowych będących pod naszą kontrolą i wykonywać swoje prawa jako właściciel tych danych zgodnie z GDPR.", j = "Akceptuję Regulamin", p = {
  "(Optional)": "(Opcjonalny)",
  and: e,
  "Apply promocode": "Zastosuj kod promocyjny",
  "Are you registered?": "Czy jesteś zarejestrowany?",
  Back: o,
  "Book Now": "Zarezerwuj teraz",
  "Call Now": "Zadzwoń teraz",
  "Click here": "Kliknij tutaj",
  Close: a,
  "Confirm your email": "Potwierdź swój adres e-mail",
  "Contact Now": "Kontakt teraz",
  Continue: i,
  days: n,
  days_abbr: s,
  Email: t,
  "Enter the validation code sent to your email": "Wprowadź kod weryfikacyjny wysłany na Twój adres e-mail",
  "Exclusive benefits unlocked!": "Ekskluzywne korzyści odblokowane!",
  "Great! Email successfully sent!": "Świetny! E-mail pomyślnie wysłany!",
  Hello: r,
  hours: l,
  hours_abbr: d,
  "I agree to the": "Wyrażam zgodę na",
  "Invalid code": "Nieprawidłowy kod",
  "Last reservation was XXXXXX hours ago": "Ostatnia rezerwacja XXXXXX godzin temu",
  minutes: y,
  minutes_abbr: c,
  none: w,
  "Not registered yet?": "Nie jesteś jeszcze zarejestrowany?",
  "Only for registered users": "Tylko dla zarejestrowanych użytkowników",
  "Only for specific rates": "Tylko dla określonych stawek",
  Optional: X,
  "Perk 1 will be listed here": "Dodatek 1 zostanie wymieniony tutaj",
  "Perk 2 will be listed here": "Perk 2 będzie wymieniony tutaj",
  "Perk 3 will be listed here": "Perk 3 będzie wymieniony tutaj",
  "Please, provide a valid e-mail": "Podaj ważny adres e-mail",
  "Privacy policy": "Polityka prywatności",
  Register: u,
  "Resend code": "Ponowne wysłanie kodu",
  seconds: m,
  seconds_abbr: z,
  "Send to booking engine": "Wyślij do mechanizmu rezerwacji",
  "Sending search": "Wysyłanie wyszukiwania",
  "Sign in": "Zaloguj się",
  "Sign in to your account": "Zaloguj się na swoje konto",
  "Something went wrong. Please, try again later.": "Coś poszło nie tak. Spróbuj ponownie później.",
  "Subject to availability": "Zależnie od dostępności",
  "Terms and conditions": "Zasady i warunki",
  Terms_default: k,
  Terms_default_label: j,
  "Thank you!": "Dziękuję Ci!",
  "There are XXXXXX people looking at this hotel right now": "XXXXXX osób właśnie ogląda tę ofertę",
  "There has been an error.": "Wystąpił błąd.",
  "This is a standard paragraph, use it to display information.": "Jest to standardowy akapit, używany do wyświetlania informacji.",
  'This is paragraph. <b>Bold</b> it, <i>italicise</i> it, <u>underline</u> it, add <a href="#">links</a>, emojis 🙂, and more!': 'To jest akapit. <b>Pogrubić</b>, <i>wyróżnić</i>, <u>podkreślić</u>, dodać <a href="#">linki</a>, emoji 🙂 i wiele więcej!',
  "Title of your message": "Tytuł wiadomości",
  "Today's special offer: XXXXXX": "Dzisiejsza świetna okazja: XXXXXX",
  "View all XXXXXX perks": "Zobacz wszystkie bonusy XXXXXX",
  "We have received your form submission correctly": "Otrzymaliśmy Twoje zgłoszenie formularza poprawnie.",
  "We will send you an email with your search very soon.": "Wkrótce wyślemy Ci wiadomość e-mail z zapytaniem",
  "Web exclusive": "Wyłącznie online",
  "XXXXXX people have already booked today": "Zarezerwowany XXXXXX razy w ciągu ostatnich 24 godzin",
  "XXXXXX people have looked at this hotel today": "XXXXXX osób oglądało tę ofertę w ciągu ostatniej doby",
  "XXXXXX% discount only today": "XXXXXX% zniżki tylko dzisiaj",
  "You must agree to the Terms & Conditions first": "Najpierw musisz zaakceptować Warunki",
  "Your email": "E-mail",
  "Your email address has been successfully added to our list.": "Twój adres e-mail został pomyślnie dodany do naszej listy."
};
export {
  o as Back,
  a as Close,
  i as Continue,
  t as Email,
  r as Hello,
  X as Optional,
  u as Register,
  k as Terms_default,
  j as Terms_default_label,
  e as and,
  n as days,
  s as days_abbr,
  p as default,
  l as hours,
  d as hours_abbr,
  y as minutes,
  c as minutes_abbr,
  w as none,
  m as seconds,
  z as seconds_abbr
};
//# sourceMappingURL=pl.DWfwQC0k.js.map
